import React from 'react';
import { Box, IconButton, Menu, MenuItem, TableCell, TableRow } from '@mui/material';
import { Customer } from '../../../models/customer.model';
import styles from '../CustomerProfiles.module.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';
import { useTranslation } from 'react-i18next';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { USER_PERMISSIONS } from '../../../common/constants/permissions';
import { useCheckPermission } from '../../../common/hooks/useCheckPermission';

type SupplierRowProps = {
  customer: Customer;
  navigateToDocs: (id: number) => void;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
};

export const CustomerRow: React.FC<SupplierRowProps> = ({
  customer,
  navigateToDocs,
  handleDelete,
  handleEdit,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const checkPermission = useCheckPermission();
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <TableRow className={styles.table_row} key={customer.id}>
      <TableCell
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.CUSTOMER_PROFILES}/${customer.id}`)}
      >
        {customer.customer_name}
      </TableCell>
      <TableCell
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.CUSTOMER_PROFILES}/${customer.id}`)}
      >
        {customer.email_address || '-'}
      </TableCell>
      <TableCell
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.CUSTOMER_PROFILES}/${customer.id}`)}
      >
        {customer.website || '-'}
      </TableCell>
      <TableCell
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${customer.id}`)}
      >
        {customer.postal_address || '-'}
      </TableCell>
      <TableCell className={styles.table_cell} align='right'>
        <Box
          className={styles.actions_container}
          display='flex'
          justifyContent='flex-end'
          gap='8px'
        >
          <IconButton
            onClick={(event) => {
              event.stopPropagation();
              setAnchorEl(event.currentTarget);
            }}
            size='small'
            sx={{ p: 0.5 }}
          >
            <MoreVertIcon fontSize='small' />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem
              disabled={!checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_UPDATE)}
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                handleEdit(customer.id);
              }}
            >
              {t('buttons.edit')}
            </MenuItem>
            <MenuItem
              disabled={
                !(
                  checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_UPDATE_DOCUMENT) ||
                  checkPermission(USER_PERMISSIONS.ORG_DOCUMENT_UPLOAD_CREATE) ||
                  checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_DELETE_DOCUMENT) ||
                  checkPermission(USER_PERMISSIONS.ORG_DOCUMENT_UPLOAD_ASSIGN_PROFILE)
                )
              }
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                navigateToDocs(customer.id);
              }}
            >
              {t('buttons.documents')}
            </MenuItem>
            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                handleDelete(customer.id);
              }}
              disabled={!checkPermission(USER_PERMISSIONS.ORG_CUSTOMER_PROFILE_DELETE)}
            >
              {t('buttons.delete')}
            </MenuItem>
          </Menu>
        </Box>
      </TableCell>
    </TableRow>
  );
};
